module.exports = __webpack_public_path__ + "static/media/wh-lockdown-nov.1cd8d1ff.pdf";